import React, {useState} from 'react'
import Button from './Button';
import { AiOutlineArrowRight } from '@react-icons/all-files/ai/AiOutlineArrowRight';
import { AiOutlineArrowLeft } from '@react-icons/all-files/ai/AiOutlineArrowLeft';


const SalesPain = ({potential, setStep, pain_points}) => {
    let [part, setPart] = useState(0)






  return <div className='sSlide'>

    <div className='row'>

{potential?.metrics?.current_model&&            <div className='slideCard'>
            <div className='cardTitle otherTitle'>
                {potential?.name} Current Model
            </div>
            <div className='cardBody'>
                <p className='bodyP'>
                    "{potential?.metrics?.current_model}"
                    </p>
                </div>
            </div>}
        </div>

{part>0 &&        <div className='painPoints'>
            <h3>How do we solve some of your current challenges</h3>
            <div className='row'>
                {Object.keys(pain_points).filter(v => potential?.metrics?.pain_points?.[v]).map((key,i)=>         <div key={i} className='slideCard painPoint'>
                    <span className='painTitle'>"{pain_points[key][0]}"</span>
                    <div className='cardBody'>

                    {pain_points[key][1]}

                    </div>
                </div>)}

            </div>
        </div>}


        <div className='buttons'>
      <Button className='btn-5  ' onClick={() => setStep(0)} ><AiOutlineArrowLeft />Back</Button>
        <Button className='btn-5  highLight' onClick={() =>part ?setStep(2) : setPart(1)} ><AiOutlineArrowRight />Continue</Button>
    </div>

  </div>
}

export default SalesPain